import {
  knowledgeWebUrl,
  loungeWebUrl,
  portalWebUrl,
  squareWebUrl,
  workplaceReputationWebUrl,
} from './baseUrl';

import { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

// ナース専科のメインコンテンツのURL
export const mainContentsUrls = (appEnv: AppEnv) => ({
  // トップ
  top: portalWebUrl(appEnv),
  // 看護知識
  knowledge: knowledgeWebUrl(appEnv),
  // 看護記事
  square: squareWebUrl(appEnv),
  // 掲示板
  lounge: loungeWebUrl(appEnv),
  //
  workplaceReputation: workplaceReputationWebUrl(appEnv),
});
